<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" :style="headerStyle">
      <div class="md-layout">
        <div class="md-layout-item">
          <div class="image-wrapper">
            <div class="brand">
              <h1>JODA</h1>
              <h3>Let's play together.</h3>
            </div>
          </div>
        </div>
      </div>
    </parallax>
    
    <div class="main main-raised">
      <div class="section">
        
      </div>
    </div>
  </div>
</template>

<script>


export default {
  components: {

  },
  name: "index",
  bodyClass: "index-page",
  props: {
    image: {
      type: String,
      default: require("@/assets/img/net.jpg")
    },
    signup: {
      type: String,
      default: require("@/assets/img/city.jpg")
    },
    landing: {
      type: String,
      default: require("@/assets/img/landing.jpg")
    },
    profile: {
      type: String,
      default: require("@/assets/img/profile.jpg")
    }
  },
  data() {
    return {
      firstname: null,
      email: null,
      password: null
    };
  },
  methods: {
    startLoading() {
      let loader = this.$loading.show({
        // Optional parameters
        container: null,
        canCancel: false,
        onCancel: this.onCancelLoading,
        color: '#3f51b5',
        backgroundColor: '#757575'
      })
      
      setTimeout(() => {
        loader.hide()
      }, 5000)                 
    },
    onCancelLoading() {
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.image})`
        // backgroundImage: `url("https://drive.google.com/uc?export=view&id=1EzGxcOqDO3ipJagJ2PNq2y6Q9xXtxgM6")`
      };
    },
    signupImage() {
      return {
        backgroundImage: `url(${this.signup})`
      };
    }
  },
  mounted() {
  },
  beforeDestroy() {

  }
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
</style>
